/* eslint-disable */
/**
 * Predictive Search functionality depends on the Search & Discovery app.
 */
'use strict';

const PredictiveSearch = {

    init: function() {
        // Add a handle to return if the search is not present on the website
        let searchInput = document.getElementById("site-header_search-input");
        this.searchResultsContainer = document.querySelector('.site-header__search-inner-holder');
        if (this.searchResultsContainer) {
          this.getSuggestions(searchInput.value, this.searchResultsContainer);
          this.handleSearch(searchInput);
          this.handleDefaultSearchOptions();
        }
    },

    handleDefaultSearchOptions: function() {
        let defaultSearchOptions = document.querySelectorAll('.site-header__search-inner-top-search-terms-link');
        defaultSearchOptions.forEach(option => {
          option.addEventListener('click', ()=> {
            const mostSearcheditems = document.querySelector('.site-header__search-inner-top-search-terms');
            mostSearcheditems.classList.remove('is-visible');
            this.getSuggestions(option.textContent, this.searchResultsContainer);
            const removeBtn = document.querySelector('.site-header__search-inner-top-remove');
            removeBtn.classList.add('is-visible');
          })
        })
    },

    handleSearch: function(searchInput){
      searchInput.addEventListener('input', ()=> {
        const mostSearcheditems = document.querySelector('.site-header__search-inner-top-search-terms');
        mostSearcheditems.classList.remove('is-visible');

        const removeBtn = document.querySelector('.site-header__search-inner-top-remove');

        if (searchInput.value.length != 0) {
          removeBtn.classList.add('is-visible');
        } else {
          removeBtn.classList.remove('is-visible')
        }
        if (searchInput.value.length > 3) {
          this.getSuggestions(searchInput.value, this.searchResultsContainer);
        }
      });

      searchInput.addEventListener('change', ()=> {
        if (searchInput.value.length == 0) {
          this.getSuggestions(searchInput.value, this.searchResultsContainer);
        }
      })
    },
    
    headerSearchTabs: function() {
      const tabButtons = document.querySelectorAll('.js-site-header__search-inner-top-search-results-tab');
      const tabBoxes = document.querySelectorAll('.js-site-header__search-inner-top-search-results-tab-boxes');

      if(tabButtons && tabBoxes){
      tabButtons.forEach(function (button, index) {
          button.addEventListener('click', function () {

              tabButtons.forEach(function (btn) {
                  btn.classList.remove('is-active');
              });
              tabBoxes.forEach(function (box) {
                  box.classList.remove('is-active');
              });

              button.classList.add('is-active');
              tabBoxes[index].classList.add('is-active');
          });
      });
    }
  },
    /**
     * Fetch predictive search & render the results
     * 
     * @param {string} searchTerm 
     * @param {object} predictiveSearchResultsElement 
     */
    getSuggestions: function(searchTerm, predictiveSearchResultsElement) {
      // When triggered remove all content from the selector
      predictiveSearchResultsElement.innerHTML = '';
      if(searchTerm != ''){
      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=query,product,collection,page,article`)
        .then((response) => {
          if (!response.ok) {
            let error = new Error(response.status);
            // this.close();
            if(response.status == 422) {
              this.close();
            }
            else {
              throw error;
            }
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
            predictiveSearchResultsElement.innerHTML = resultsMarkup;
            this.headerSearchTabs();
        })
        .catch((error) => {
          if (error.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          // this.close();
          // throw error;
        });
    }
  }
};

export default PredictiveSearch;